import { Router } from "@angular/router";
var EntryComponent = /** @class */ (function () {
    function EntryComponent(router) {
        this.router = router;
    }
    EntryComponent.prototype.ngOnInit = function () {
        var theURL = window.location.pathname;
        var urltab = theURL.split('/');
        window.location.href = urltab[0] + '/connect.html';
    };
    return EntryComponent;
}());
export { EntryComponent };



// WEBPACK FOOTER //
// ./src/app/page/entry/entry.component.ts.pre-build-optimizer.js